import React, { useEffect, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import axios from 'axios';
import { useIntl } from 'react-intl';
import { Popup, PopupContent } from '@flatfy/supernova-new';
import FlatsFiltersActions from './FlatsFiltersActions/FlatsFiltersActions';
import FlatsFiltersHeader from './FlatsFiltersHeader/FlatsFiltersHeader';
import FlatsFiltersRange from './FlatsFiltersRange/FlatsFiltersRange';
import FlatsFiltersPriceRange from './FlatsFiltersPriceRange/FlatsFiltersPriceRange';
import FlatsFiltersSection from './FlatsFiltersSection/FlatsFiltersSection';
import FlatsFiltersSelect from './FlatsFiltersSelect/FlatsFiltersSelect';
import FlatsFiltersSorting from './FlatsFiltersSorting/FlatsFiltersSorting';
import FlatsFiltersSwitch from './FlatsFiltersSwitch/FlatsFiltersSwitch';
import FlatsFiltersPopup from './FlatsFiltersPopup/FlatsFiltersPopup';
import { FlatsFiltersContentContext, FlatsFiltersOpenedContext } from './FlatsFiltersContext';
import { isChromeIos } from '../helpers/browserCheck';
import useMediaQuery from './useMediaQuery';

const FlatsFilters = ({
  requestUrl,
  requestParams,
  onResponse,
  children,
  className,
  skipKeys,
  triggerEl,
  onClose = () => {},
}) => {
  const [opened, setOpened] = useContext(FlatsFiltersOpenedContext);
  const { searchParams } = useContext(FlatsFiltersContentContext);
  const [isLoading, setIsLoading] = useState(true);
  const body = document.querySelector('body');
  const noTransitions = isChromeIos();
  const isMobile = useMediaQuery();
  const intl = useIntl();

  const handleClose = () => {
    body.classList.remove('UIPopup-no-scroll');
    setOpened(false);
    onClose();
  };

  useEffect(() => {
    axios({
      url: requestUrl,
      method: 'post',
      headers: {
        'Content-type': 'application/json',
        'X-CSRF-Token': window.csrf,
      },
      withCredentials: true,
      data: {
        ...(requestParams || {}),
        ...searchParams,
      },
    })
      .then((response) => {
        onResponse(response);
      })
      .finally(() => {
        setIsLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  return (
    !isLoading && (
      <div className="FlatsFilters">
        {isMobile ? (
          <Popup
            className={className}
            opened={opened}
            onClose={handleClose}
            anchorEl={triggerEl}
          >
            <PopupContent
              className={cx('FlatsFilters-content', { '-no-transitions': noTransitions })}
              headerTitle={intl.formatMessage({ id: 'filters' })}
              onClose={handleClose}
              actions={<FlatsFiltersActions skipKeys={skipKeys} onClose={handleClose} />}
            >
              {children}
            </PopupContent>
          </Popup>
        ) : (
          children
        )}
      </div>
    )
  );
};

FlatsFilters.propTypes = {
  requestUrl: PropTypes.string.isRequired,
  requestParams: PropTypes.object,
  onResponse: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  skipKeys: PropTypes.array,
  triggerEl: PropTypes.object,
  onClose: PropTypes.func,
};

FlatsFilters.Actions = FlatsFiltersActions;
FlatsFilters.Header = FlatsFiltersHeader; // todo: remove
FlatsFilters.Range = FlatsFiltersRange;
FlatsFilters.PriceRange = FlatsFiltersPriceRange;
FlatsFilters.Section = FlatsFiltersSection;
FlatsFilters.Select = FlatsFiltersSelect;
FlatsFilters.Sorting = FlatsFiltersSorting;
FlatsFilters.Switch = FlatsFiltersSwitch;
FlatsFilters.Popup = FlatsFiltersPopup;

export default FlatsFilters;
